module.exports = __webpack_public_path__ + "static/img/css3_logo.ec3e6e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css3_logo.png
// module id = y/Ay
// module chunks = 0